import React, { FC, ComponentProps } from 'react'
import wrappedContracts from '../constants/wrappedContracts'
import { useAccount, useChains } from 'wagmi'
import FormatCryptoCurrency from './FormatCryptoCurrency'

type Props = ComponentProps<typeof FormatCryptoCurrency> & {
  logoWidth?: number
  address?: string
}

const FormatWrappedCurrency: FC<Props> = ({ logoWidth, address, ...props }) => {
  const { chain: activeChain } = useAccount()
  const chains = useChains()
  let chain = chains.find((chain) => activeChain?.id === chain.id)

  if (!chain && chains.length > 0) {
    chain = chains[0]
  } else {
    chain = activeChain
  }

  const contractAddress =
    chain?.id !== undefined && chain.id in wrappedContracts
      ? wrappedContracts[chain.id]
      : wrappedContracts[1]

  return (
    <FormatCryptoCurrency {...props} address={address || contractAddress} />
  )
}

export default FormatWrappedCurrency
